import { combineReducers } from 'redux';
import orderedItems from './ordered-items';

export default combineReducers({
  orderedItems
});
